module.exports = __webpack_public_path__ + "static/img/A167.45be59cd.jpg";